/**
 * Previous reports dropdown logic
 */
function initPreviousReports() {
	const previousReportsTrigger = document.querySelectorAll('.previous-reports-trigger');
	previousReportsTrigger.forEach((triggerButton) => {
		const container = triggerButton.closest('.previous-reports');
		const list = triggerButton.parentElement.querySelector('ul.previous-reports-list');
		const handleOverflowing = () => {
			const overflowing = isOverflowing(list);
			if (overflowing === 'top') {
				container.classList.remove('side-top');
				container.classList.add('side-bottom');
			} else if (overflowing === 'bottom') {
				container.classList.add('side-top');
				container.classList.remove('side-bottom');
			}
		}
		handleOverflowing();
		triggerButton.addEventListener('click', (event) => {
			handleOverflowing();
			const willClose = triggerButton.classList.contains('open');
			triggerButton.setAttribute('aria-expanded', willClose ? 'false' : 'true')
			triggerButton.classList.toggle('open', !willClose);
			list.classList.toggle('open', !willClose);
		})

		clickedOutside('ul.previous-reports-list', function () {
			triggerButton.classList.remove('open');
			list.classList.remove('open');
		}, ['.previous-reports-trigger']);
	})
}
